import React from "react";
import TopBarStaffOperations from "../TopBarStaffOperations";
import { Container, ContentWrapper } from "./styles";

const MainStaffOperationsHeader = ({ children }) => {
  return (
    <Container>
      <TopBarStaffOperations />
      <ContentWrapper>{children}</ContentWrapper>
    </Container>
  );
};

export default MainStaffOperationsHeader;
